<template>
  <div></div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    console.log('这是数据123132', from)
    next(xq => {
      //要注意，必须使用this.$router.replace而非this.$router.push
      //如果使用的是this.$router.push会导致，进入过空白页之后，通过浏览器的后退键，无法实现页面后退的bug现象
      let obj = JSON.parse(window.localStorage.getItem('detailsObj'))
      let path = from.path.split('/')[1]
      xq.$router.replace({name: path, params: obj})
    })
  }
}
</script>

<style></style>
